export default "__VITE_ASSET__CxNKzqq___"